import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import GoogleAnalytics from 'react-ga';

import Train from '../../services/train.js';
import User from '../../services/User.js';
import Element from '../../services/Element.js';
import Notification from '../../services/Notification.js';

class SignupForm extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      onClose: props.onClose,
      onFormChange: props.onFormChange
    }
  }

  validate() {
    this.setState({});
  }

  differentPasswords() {

    if (!this.refs.password  || !this.refs.cpassword)
      return false;

    return this.refs.cpassword.value.length > 0 && this.refs.password.value !== this.refs.cpassword.value
  }

  invalid() {

    if (!this.refs.username || !this.refs.email  || !this.refs.password  || !this.refs.cpassword)
      return true;


    return (
      !this.refs.username.validity.valid ||
      !this.refs.email.validity.valid ||
      !this.refs.password.validity.valid ||
      !this.refs.cpassword.validity.valid ||
      this.differentPasswords()
    );
  }

  successfulLogin(result) {

    GoogleAnalytics.event({
      category: 'User',
      action: 'emailSignup'
    });


    this.state.onClose();
    User.startSession(result.token);
    let user = {user: User.getId(), name: User.getName()};
    this.props.history.push(Element.url('user', user));
    Notification.show(`Welcome, ${User.getName()}`, 'success');
  }

  failedLogin(error) {
    Notification.show(`E-mail already registered`, 'error');
  }

  signup(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    let username = this.refs.username.value;
    let email = this.refs.email.value;
    let password = this.refs.password.value;
    Train.createUser({username, email, password})
    .then(this.successfulLogin.bind(this))
    .catch(this.failedLogin.bind(this));
  }

  switchToLoginForm(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    this.state.onFormChange('login');
  }

  render() {

    return (

      <form onSubmit={this.signup.bind(this)} className="userForm" noValidate >
        <fieldset>

          <a className="closeButton" onClick={this.state.onClose}> 
            <i className="fontastic icon-close clickable"></i>
          </a>

          <h2 className="fs-title">Sign up</h2>

          <input onChange={this.validate.bind(this)} autoFocus ref="username" type="text" pattern="((?!@)[\d\w])+" minLength="4" maxLength="20" required placeholder="Username"/>
          
          { this.refs.username && this.refs.username.validity.tooShort && <div>Your username should contain at least 4 characters</div> }
          { this.refs.username && this.refs.username.validity.tooLong && <div>Your username should contain no more than 20 characters</div> }
          { this.refs.username && this.refs.username.validity.patternMismatch && <div>Your username should contain only numbers or letters</div> }


          <input onChange={this.validate.bind(this)} ref="email" type="email" minLength="4" maxLength="80" pattern="([\w\-\.\+]+@([\w\-]+\.)+[\w\-]{2,4})?" required placeholder="Email" />

          { this.refs.email && this.refs.email.validity.patternMismatch && <div>Enter a valid e-mail address</div> }

          <input onChange={this.validate.bind(this)} ref="password" type="password" id="passwordField" minLength="8" maxLength="20" required placeholder="Password" />

          { this.refs.password && this.refs.password.validity.tooShort && <div>Your password should contain at least 8 characters</div> }
          { this.refs.password && this.refs.password.validity.tooLong && <div>Your password should contain no more than 20 characters</div> }

          <input onChange={this.validate.bind(this)} ref="cpassword" type="password" minLength="8" maxLength="20" required placeholder="Confirm Password" />

          { this.differentPasswords() && <div>Your confirmation must match your password</div> }

          <input disabled={this.invalid()} type="submit" className="submit action-button" value="Submit" /> 
          <a className="switchLink clickable" onClick={this.switchToLoginForm.bind(this)}>Already a user?</a>
        </fieldset>
          
      </form>

    );
  }

}

export default withRouter(SignupForm);



// WEBPACK FOOTER //
// ./src/js/components/credentials/SignupForm.jsx